module.exports = __webpack_public_path__ + "img/OVO.1c7abef0.png";